import { styled } from "@mui/material/styles";
import useVariant from "hooks/useVariant";
import { EXTERNAL_ICONS } from "shared/enum";

function StreamLoadingScreen({ isLoading }: { isLoading: boolean }) {
  const variant = useVariant();
  if (!isLoading) return <></>;

  return (
    <Container>
      <LoadingImagesContainer>
        <LoadingVehicleImage src={EXTERNAL_ICONS[`${variant?.code}_VEHICLE_IMG`]} />
        <LoadingCircleImage src={EXTERNAL_ICONS.LOADING_OVERLAY_CIRCLE_IMG} />
      </LoadingImagesContainer>
    </Container>
  );
}

export default StreamLoadingScreen;

const Container = styled("div")`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000;
  z-index: 950;
  ${({ theme }) => theme.breakpoints.down("md")} {
    row-gap: 0;
  }
`;

const LoadingImagesContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  row-gap: 1.5rem;
  ${({ theme }) => theme.breakpoints.down("md")} {
    row-gap: 0;
  }
`;

const LoadingCircleImage = styled("img")`
  width: 75px;
  ${({ theme }) => theme.breakpoints.between(900, 1100)} {
    width: 70px;
    margin-top: -30px;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 45px;
    margin-top: -20px;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    width: 40px;
  }
`;

const LoadingVehicleImage = styled("img")`
  width: 45%;

  ${({ theme }) => theme.breakpoints.between(900, 1100)} {
    width: 30%;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 40%;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    width: 50%;
  }

  ${({ theme }) => theme.breakpoints.down(425)} {
    width: 80%;
  }
`;
